import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Accounts = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel9-content"
                id="panel9-header"
            >
                When does a brand or producer need a separate account?
            </AccordionSummary>
            <AccordionDetails>
                <Typography sx={{ fontSize: "14px" }}>
                    What is considered a separate brand in Dippi? Every individual brand profile
                    requires a separate account within Dippi. If a set of your products possesses a
                    distinctive producer details, such as a unique logo, different name, you will
                    need a separate Dippi brand account to oversee those wines. All your accounts
                    can be efficiently managed using your company profile and creating new brand
                    profile with “New brand” button.
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
};

export default Accounts;
